import { tap } from 'lodash/fp';
import * as designBuilderApi from '../api/designBuilder';
import estimateLoaded from './estimateLoaded';
import loaded from './loaded';
import loading from './loading';
import globalError from './globalError';

export default (containerId, newName) => (dispatch, getState) => {
  dispatch(loading());

  const { uiState } = getState().estimateBuilder;
  const { selectedEstimate } = uiState;

  return designBuilderApi
    .renameContainer(selectedEstimate, containerId, newName)
    .then(response => dispatch(estimateLoaded(response.data)))
    .then(tap(() => dispatch(loaded())))
    .catch(err => dispatch(globalError({ err })));
};
